import { z } from 'zod';

// Task schema for checked tasks
export const checkedTaskSchema = z.object({
	id: z.number(),
	name: z.string(),
	isActive: z.boolean(),
});

export type CheckedTask = z.infer<typeof checkedTaskSchema>;

// Invalid task schema (for error display)
export const invalidTaskSchema = z.object({
	id: z.number(),
	name: z.string(),
});

export type InvalidTask = z.infer<typeof invalidTaskSchema>;

// Component state schema
export const activeToggleFormStateSchema = z.object({
	isFormValid: z.boolean(),
	isLoading: z.boolean(),
	isActive: z.boolean(),
	isLocationTaskListActive: z.boolean(),
	showErrorModal: z.boolean(),
	invalidTasks: z.array(invalidTaskSchema),
	copied: z.boolean(),
});

export type ActiveToggleFormState = z.infer<typeof activeToggleFormStateSchema>;

// Active toggle response schema
export const activeToggleResponseSchema = z.object({
	isError: z.boolean(),
	errors: z.array(z.string()).optional(),
	payload: z.object({
		invalidBaselineTasks: z.array(invalidTaskSchema).optional(),
	}).optional(),
});

export type ActiveToggleResponse = z.infer<typeof activeToggleResponseSchema>;

// BaselineTask actions interface
export interface BaselineTaskActions {
	activeToggle: (taskIds: number[], isActive: boolean, isLocationTaskListActive: boolean) => Promise<ActiveToggleResponse>;
}

// Component props schema
export const activeToggleFormPropsSchema = z.object({
	tasksChecked: z.array(checkedTaskSchema),
	baselineTaskActions: z.object({}), // Using BaselineTaskActions interface
	listingRefresh: z.function(),
});

export interface ActiveToggleFormProps {
	tasksChecked: CheckedTask[];
	listingRefresh: () => void;
}

// Form validation result interface
export interface ValidationResult {
	isValid: boolean;
	errors?: string[];
}